import { AlertCircle, AlertTriangle, CheckCircle2 } from "lucide-react";

import type { McpHealthStatus } from "@/api/types";
import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface Props {
  status: McpHealthStatus | null;
  checkedAt: string | null;
}

const STALE_THRESHOLD_MS = 10 * 60 * 1000; // 10 min

export function McpHealthBadge({ status, checkedAt }: Props) {
  const checkedAtMs = checkedAt ? new Date(checkedAt).getTime() : null;
  const ageMs =
    checkedAtMs !== null ? Date.now() - checkedAtMs : Number.POSITIVE_INFINITY;
  const isStale = ageMs > STALE_THRESHOLD_MS;

  let variant: "default" | "destructive" | "outline";
  let label: string;
  let Icon = AlertTriangle;

  if (status === "ok" && !isStale) {
    variant = "default";
    label = "Saudavel";
    Icon = CheckCircle2;
  } else if (status === "error") {
    variant = "destructive";
    label = "Falhou";
    Icon = AlertCircle;
  } else {
    variant = "outline";
    label = checkedAt ? "Stale" : "Sem check";
    Icon = AlertTriangle;
  }

  const tooltip = checkedAt
    ? `Ultimo check: ${new Date(checkedAt).toLocaleString("pt-BR")}`
    : "Nunca foi verificado";

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge variant={variant} className="gap-1">
            <Icon className="h-3 w-3" />
            {label}
          </Badge>
        </TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
